import React, { useEffect, useState } from 'react';

// import { Link } from 'react-router-dom';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';

// import DesktopMenu from '../common/components/Navigation/DesktopMenu.js';

import Header from '../common/components/Header.js';
import Footer from '../common/components/Footer.js';
import { URL_ROOT } from '../common/globalConstants.js';
import {default as imagePath} from "../assets/images/Loading.svg";

const Staff = (props) => {

	const {
		allTextBlocks,
		description,
		history,
		locationId,
		textBlocks,
		staffList,
		title
	} = props;

	// eslint-disable-next-line
	const [pageTextBlocks, setPageTextBlocks] = useState([]);
	const [locationStaff, setLocationStaff] = useState([]);

	useEffect(() => {

		if(allTextBlocks && allTextBlocks.length > 0) {
			if(textBlocks) {
				const currentTextBlocks = [];
				let matchingTextBlock = [];
				if(!Array.isArray(textBlocks)) {
					// eslint-disable-next-line
					matchingTextBlock = allTextBlocks.filter(x => x.id == textBlocks.TextBlockId);
					if(matchingTextBlock && matchingTextBlock.length === 1) {
						currentTextBlocks.push(matchingTextBlock[0]);
					}
				} else {
					for(let i = 0; i < textBlocks.length; i++) {
						// eslint-disable-next-line
						matchingTextBlock = allTextBlocks.filter(x => x.id == textBlocks[i].TextBlockId);
						if(matchingTextBlock && matchingTextBlock.length === 1) {
							currentTextBlocks.push(matchingTextBlock[0]);
						}
					}
				}

				setPageTextBlocks(currentTextBlocks);
			}
		} else {
			history.push(URL_ROOT);
		}

		if(staffList && staffList.length > 0) {
			const currentStaffList = [];
			for(let i = 0; i < staffList.length; i++) {
				const currentStaffMember = staffList[i];
				if (currentStaffMember.Locations && currentStaffMember.Locations.length > 0 && currentStaffMember.Active) {
					for(let j = 0; j < currentStaffMember.Locations.length; j++) {
						// eslint-disable-next-line
						if(currentStaffMember.Locations[j].LocationId == locationId) {
							currentStaffList.push(staffList[i]);
						}
					}
				}
			}

			setLocationStaff(currentStaffList);
		}
	// eslint-disable-next-line
	}, []);

	return (
		<React.Fragment>
			<MetaTags>
				<title>{title}</title>
				<meta name="description" content={description} />
				<meta property="og:title" content={title} />
			</MetaTags>
			<Header locationId={locationId} />
			<main>
				<div className='content'>
					<div className='pageContent'>
						{locationStaff.sort((a, b) => (a.Order > b.Order) ? 1 : -1).map(staffMember => {
							let imagePath = require('../assets/images/Loading.svg');
							if(staffMember.ImageUrl && staffMember.ImageUrl.length > 0) {
								imagePath = require('../assets/images/' + staffMember.ImageUrl);
							}

							let displayText = <div className='staffBioText' dangerouslySetInnerHTML={{__html: '<h2>' + staffMember.DisplayHeading + '</h2>'}} />;
							if(staffMember.BioText && staffMember.BioText.length > 0) {
								displayText = <div className='staffBioText' dangerouslySetInnerHTML={{__html: '<h2>' + staffMember.DisplayHeading + '</h2>' + staffMember.BioText}} />;
							}

							return (
								<div key={staffMember.id} className='staffBio'>
									<img src={imagePath} className='staffBioImage' alt={staffMember.DisplayHeading} />
									{displayText}

								</div>
							);
						})}

						{/*
							<div className='staffBio'>
							<img src="/" className='staffBioImage' />
							<div className='staffBioText'>
							<h2>Lauren Canna</h2>
							<p>
							Ms. Canna holds a BM in Voice from Rutgers University and an MM in Choral Conducting from Temple University.  She has completed additional studies at Westminster Choir College and Rowan University. Owner of AfterSchool Music, Ms. Canna maintains a selective studio.
							</p>
							<p>
							She is the former conductor of the Garden State Girlchoir, (a part of the Commonwealth Youthchoir Systems and cousin to the renowned Pennsylvania Girlchoir).  She was the Program Director of the Pitman Recreation Theater for many years.  She has taught voice and conducted the choir at Cumberland County College for 10 years, has taught at Buena Regional High School, Cape May Technical High School, and the New Jersey School of Music.
							</p>
							<p>
							She is especially proud to have taught over 25 local music teachers and maintains a warm and collegial relationship with many of her former students and their families.  Many of her students have become professional performing musicians, music academics, working actors, music therapists, and studio musicians.
							</p>
							</div>
							</div>

							<div className='staffBio'>
							<img src="/" className='staffBioImage' />
							<div className='staffBioText'>
							<h2>Jessica Nelson &mdash; Voice</h2>
							<p>
							Ms. Nelson enjoys teaching both voice and piano.  She is a professional singer of opera and art song, and has sung with various companies - Delaware Valley Opera Company, New York Opera Forum, and Bohème Opera of NJ, to name a few.
							</p>

							<p>
							Some of her favorite roles include Gretel in Humperdinck’s Hansel and Gretel, Susanna in The Marriage of Figaro, and Musetta in La Bohème, a role she studied and performed in part at the Manhattan School of Music Summer Voice Festival. Jessica completed her Master of Music degree in vocal performance at Temple University. She holds undergraduate degrees from the University of Delaware and Rowan University.
							</p>

							</div>
							</div>

							<div className='staffBio'>
							<img src="/" className='staffBioImage' />
							<div className='staffBioText'>
							<h2>Christa Conklin &mdash; Saxophone, Flute, Clarinet, Piano</h2>
							<p>
							Ms. Conklin holds a BA from Rutgers University in both Music Performance and Communication and an MALS from Monmouth University. She worked in the education department of the New York Philharmonic and, while at Lincoln Center, played with Juilliard chamber ensembles as a classical saxophonist. This allowed her the joy of performing in Alice Tully Hall.
							</p>
							<p>
							In addition to studying woodwinds, and playing them in wind ensembles and big bands, Ms. Conklin played electric bass guitar in jazz ensembles and pit bands. Providing private instrumental and french language instruction to students led her to prefer to teach outside of the classroom and inspired her to homeschool her own children. In case you are wondering why she is holding a book in her picture, Ms. Conklin is also an author.
							</p>
							</div>
							</div>

							<div className='staffBio'>
							<img src="/" className='staffBioImage' />
							<div className='staffBioText'>
							<h2>David Van Antwerp &mdash; Voice, Guitar, Piano, Composition, Theory</h2>
							<p>
							David has been working as a music educator, choir director, and musician for over 30 years, but his love of music began in his childhood with his studies of the piano, guitar, and voice. As a student, he sang with various honors ensembles in New Jersey from regional, state, and national choruses as well as performing as a guitarist and pianist in various school, church, and community groups.
							</p>
							<p>
							David holds a Bachelor of Arts in Music Education from Rowan University.   David applied his musical experience and training to the community in a variety of ways, including Church Musician / Choir Director (Our Lady Queen of Peace in Pitman), Music Therapist, and Director of Choral Activities at Washington Township High School.
							</p>
							<p>
							In all of his roles, he has provided one-on-one, small-group, and large- group musical activities, instruction and performance leadership. Along with his directorial responsibilities, David has also taught guitar class, music theory and composition, and music appreciation.
							</p>
							</div>
							</div>


							<div className='staffBio'>
							<img src="/" className='staffBioImage' />
							<div className='staffBioText'>
							<h2>Alexis Goeller &mdash; Piano</h2>
							<p>
							Alexis is a recent graduate of Immaculata University with a B.A. in Music, concentration in piano and a minor in psychology. Her interest in Music Therapy and her experience with special needs children makes her an asset on our teaching staff.  She started studying when she was 8 years old and has participated in multiple recitals and performances.  In college Alexis participated in chorale, woodwind ensemble, clarinet ensemble, and concert band, all the while studying piano. Also while in college, Alexis began her teaching career. She loves working with children of all ages and abilities. Alexis believes learning an instrument of any kind should be a fun and
							relaxing experience!
							</p>
							</div>
							</div>

							<div className='staffBio'>
							<img src="/" className='staffBioImage' />
							<div className='staffBioText'>
							<h2>Brad Leonard &mdash; Trumpet</h2>
							<p>
							Brad Leonard has been playing the trumpet for the past 20 years. He is a graduate of Messiah College with a B.S. in Music Education. At Messiah College, he played in many ensembles and also helped host the National Trumpet Competition. Brad is currently the Band Director/Music Teacher at The King's Christian School located in Cherry Hill and has been teaching there for the last 7 years. Brad has participated in ensembles in South Jersey such as the Philharmonic of Southern New Jersey, the Atlantic Brass Band, and Becks Philadelphia Brigade Band.
							</p>

							</div>
							</div>


							<div className='staffBio'>
							<img src="/" className='staffBioImage' />
							<div className='staffBioText'>
							<h2>Molly Carfagno</h2>
							<p></p>
							</div>
							</div>
							​
							<div className='staffBio'>
							<img src="/" className='staffBioImage' />
							<div className='staffBioText'>
							<h2>Salvatore Mazzocca</h2>
							<p></p>
							</div>
							</div>

							*/}

						</div>
					</div>
				</main>
				<Footer locationId={locationId} />
			</React.Fragment>
		);
	};

	const mapStateToProps = state => {
		return {
			allTextBlocks: state.application.textBlocks,
			staffList: state.application.staffList
		};
	};

	export default withRouter(connect(mapStateToProps, null)(Staff));
